import(/* webpackMode: "eager" */ "/app/app/(data-intensive)/project/activities/[id]/page.tsx");
